// extracted by mini-css-extract-plugin
export default {"block":"ListTypeABlock_block__gsG+y","text":"ListTypeABlock_text__EWKzz"};